import { MijnRoute } from '../../mijn-navigatie.model';

export const INCASSO_BATCHES_DETAILS: MijnRoute = {
    path: 'details',
    navigationEvent: 'toIncassobatchesDetails',
    regex: /^\/incassobatches\/details$/,
    webcomponent: 'mijn-incassobatches-webcomponent',
    internalPath: '/details'
};
